import React, { useCallback, useEffect, useMemo, useState } from 'react'
import classes from './index.module.scss'
import { Table } from '@Root/components'
import { API } from '@Root/API'
import { useLocation } from 'react-router'
import { useDispatch } from 'react-redux'
import { snackbarActions } from '@Root/store'
import { errorMessage } from '@Root/helpers'

export const TableReports = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const tab = location.pathname.split('/')[4]
  const [tableOptions, setTableOptions] = useState({})

  const styleConfig = {
    datePeriodDropdownStyle: {
      top: '-200px',
    },
  }

  const reportsStudentLoad = useCallback(() => {
    return {
      table: () => {
        return {
          name: 'student-load',
          fetchDataHandler: async params => {
            const response = await API.preHesaChecks.getReports(tab, {
              ...params,
              rule: 'rp_student_load:80;student_course_session_mode:31 Part time;trashed:No',
              rulesForFields: 'rp_student_load:more;student_course_session_mode:is;trashed:is',
            })
            const { student_course_session_modes } = response.data.options
            if (student_course_session_modes.length !== tableOptions?.student_course_session_modes?.length) {
              setTableOptions({
                [tab]: {
                  student_course_session_mode: student_course_session_modes.map(obj => ({
                    value: `${obj.code} ${obj.label}`,
                    label: `${obj.code} - ${obj.label}`,
                  })),
                },
              })
            }
            return response
          },
          fetchColumnOptions: () => API.getColumnOptions('student-load'),
          fetchSaveColumnOptions: options => API.saveColumnOptions('student-load', options),
          hasSorting: true,
          hasFilters: true,
          options: tableOptions[tab],
        }
      },
    }
  }, [tableOptions[tab]])

  const reportsLastProvider = useCallback(() => {
    return {
      table: () => {
        return {
          name: 'left-last-provider',
          fetchDataHandler: params => API.preHesaChecks.getReports(tab, params),
          fetchColumnOptions: () => API.getColumnOptions('left-last-provider'),
          fetchSaveColumnOptions: options => API.saveColumnOptions('left-last-provider', options),
          hasSorting: true,
          hasFilters: true,
        }
      },
    }
  }, [])

  const tableData = useCallback(
    () => ({
      'student-load': reportsStudentLoad(),
      'left-last-provider': reportsLastProvider(),
    }),
    [tableOptions[tab]]
  )

  const onError = error => {
    dispatch(snackbarActions.setSnackbar({ text: errorMessage(error), isError: true }))
  }

  const onSuccess = message => {
    dispatch(snackbarActions.setSuccessNotification({ text: message }))
  }

  const table = useMemo(() => tableData()[tab].table(), [tab, tableData])

  return (
    <div className={classes.wrapper}>
      <Table
        key={table.name}
        name={table.name}
        columns={table.columns}
        fetchDataHandler={table.fetchDataHandler}
        fetchColumnOptions={table.fetchColumnOptions}
        fetchSaveColumnOptions={table.fetchSaveColumnOptions}
        hasRules={table.hasRules}
        hasSorting={table.hasSorting}
        hasFilters={table.hasFilters}
        checkboxes={table.checkboxes}
        mandatoryRules={table.mandatoryRules}
        exceptionsFetchDataHandlers={table.exceptionsFetchDataHandlers}
        errorHandler={onError}
        successHandler={onSuccess}
        options={table.options}
        permissions={table.permissions}
        styleConfig={styleConfig}
      />
    </div>
  )
}
